import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import ApprovalAllowanceApplication from 'components/organismos/master/attend/ApprovalApplication/ApprovalAllowanceApplication';

const ApprovalAllowanceApplicationPage = () => (
  <SidebarTemplate pageTitle="手当申請 承認・否決">
    <ApprovalAllowanceApplication />
  </SidebarTemplate>
);

export default ApprovalAllowanceApplicationPage;
